import React from 'react';

type Props = {
  identifier: string;
  title: string;
  investmentType: string;
  onClick: () => void;
  className?: string;
};

export const PossessedItem = (props: Props): React.ReactElement => {
  const goSymbolDetail = (): void => {
    if (props.investmentType === 'US_ETF') return;

    props.onClick();
  };

  return (
    <>
      <div
        className={`grid pl-4 py-3 cursor-pointer ${props.className ?? ''}`}
        style={{ gridTemplateColumns: '1fr auto' }}
        onClick={() => goSymbolDetail()}>
        <div className="flex flex-col">
          <div className="text-sm text-bluegray-500">{props.identifier}</div>
          <div className="mt-1 text-bluegray-700 text-sm font-bold line-clamp-2">
            {props.title}
          </div>
        </div>
        {props.investmentType !== 'US_ETF' ? (
          <div className="icon-chevron-right w-5 flex items-center justify-center text-lg text-bluegray-500"></div>
        ) : (
          <div className="w-5" />
        )}
      </div>
    </>
  );
};
